<div class="container">
    <div class="loading-spinner" *ngIf="loading" role="alert">
        <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
        <div class="spinner">
            <div></div>
            <div></div>
        </div>
        <div class="loading-text">Loading..</div>
    </div>
    <div class="row">
        <div class="col-24">
            <h1>eApplication History</h1>
        </div>
    </div>
    <form (keydown)="onKeyDown($event)">
        <fieldset>
            <legend>Search for an eApplication</legend>
            <label *ngIf="IsrecordFound" style="color:red;">{{serviceResponse}}</label>
            <div class="row">
                <div class="col-8">
                    <div class="input-wrapper">
                        <label for="BeneficiaryName">Beneficiary Name</label><input type="text" id="BeneficiaryName"
                                                                                    name="BeneficiaryName" [(ngModel)]="searchInsertModel.BeneficiaryName">
                    </div>
                </div>
                <div class="col-8">
                    <div class="input-wrapper">
                        <label for="BeneficiaryEmail">Beneficiary Email</label><input type="text" id="BeneficiaryEmail"
                                                                                      name="BeneficiaryEmail" [(ngModel)]="searchInsertModel.BeneficiaryEmail" />
                    </div>
                </div>
            </div>
            <div *ngIf="showAgentID; else other_content">
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper">
                            <label for="Agent ID">Agent ID</label><input type="text" id="AgentId"
                                                                         name="AgentId" [(ngModel)]="searchInsertModel.UserId" />
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="input-wrapper wide">

                            <label for="Agent ID">Status</label>
                            <select [(ngModel)]="searchInsertModel.Status" id="status" name="status">
                                <option *ngFor="let status of beneficiaryStatus" value={{status.text}}>
                                    {{status.value}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #other_content>
                <div class="row">
                    <div class="col-8">
                        <div class="input-wrapper wide">

                            <label for="Agent ID">Status</label>
                            <select [(ngModel)]="searchInsertModel.Status" id="status" name="status">
                                <option *ngFor="let status of beneficiaryStatus" value={{status.text}}>
                                    {{status.value}}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </ng-template>

        </fieldset>

        <div class="row">
            <div class="col-16">
                <div class="dropdown-notes">
                    <p><strong>Status Definitions</strong></p>
                    <ul>
                        <li><strong>In Progress:</strong> Link has been sent to beneficiary.</li>
                        <li><strong>Expired:</strong> eApplication link expired after 14 days.</li>
                        <li><strong>Failed:</strong> Could not confirm the beneficiary’s identity.</li>
                        <li><strong>Viewed:</strong> Viewed by beneficiary, but not signed.</li>
                        <li><strong>Correction:</strong> The beneficiary has reviewed the form, but edits are needed.</li>
                        <li><strong>Signed:</strong> The beneficiary has approved and signed the form.</li>
                        <li><strong>Rejected:</strong> The beneficiary has rejected the enrollment application.</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <button id="search" class="button primary" (click)="searcheAppHistoryData(searchInsertModel)">Search</button>
                <button id="submitSOA" class="button primary" *ngIf="showEnrollmentButton" (click)="newApplication()">Start new eApplication</button>
            </div>
        </div>
    </form>
    <div class="row">
        <div class="col-24">
            <button id="exportToExcel" class="button link excel" (click)="exportToExcel()">Export to Excel</button>
        </div>
    </div>
    <div style="display:none" id="exportTable">
        <table>
            <thead>
                <tr>
                    <th>Beneficiary Name</th>
                    <th>Beneficiary Email</th>
                    <th>Agent ID</th>
                    <th>Status</th>
                    <th>Date Created</th>
                    <th>Plan Year</th>
                    <th></th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let exp of beneficiarySOAViewModel">
                    <td>{{exp.BeneficiaryName}}</td>
                    <td>{{exp.BeneficiaryEmail}}</td>
                    <td>{{exp.UserId}}</td>
                    <td>{{exp.ApplicationStatus}}</td>
                    <td>{{exp.RecCreateTS}}</td>
                    <td>{{exp.PlanYear}}</td>
                    <td hidden="hidden">{{exp.UniqueLink}}</td>
                </tr>
            </tbody>


        </table>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="fileNotFound">{{downloadError}}</div>
        </div>
    </div>

    <div class="row">
        <div class="col-24">
            <jqxGrid (onCellclick)="CellclickOnEdit($event)"
                     [width]="1225"
                     [height]="630"
                     [source]="dataAdapter"
                     [columns]="columns" #gridReference
                     [pageable]="true"
                     [pagesizeoptions]="[20, 50, 100]"
                     [pagesize]="20"
                     [columnsresize]="true"
                     [sortable]="true"
                     [autoshowcolumnsmenubutton]="false"
                     [filterable]="true"
                     [enabletooltips]="true"
                     [selectionmode]="'multiplecellsadvanced'"
                     [virtualmode]="true"
                     [rendergridrows]="rendergridrows"
                     [updatefilterconditions]="updatefilterconditions"
                     [ready]="ready"
                     (onSort)="onSort($event)"
                     (onFilter)="onFilter($event)"
                     (onPagesizechanged)="onPageSizeChanged($event)">
            </jqxGrid>
        </div>
    </div>
</div>
